import { CURRENT_PLANS, IPlanMetadata, PREMIUM_PLANS } from '../../constants/premium';
import { centsToDollars } from '../../helpers/currency';
import { getDiscountPrice } from '../../helpers/premium';
import { ICoupon } from '../../interfaces/stripe';

const couponAdjustedPaymentPlan = (plan: IPlanMetadata, coupon: ICoupon): IPlanMetadata => {
  return {
    ...plan,
    price: centsToDollars(getDiscountPrice(coupon)),
    originalPrice: plan.price,
  };
};

export const getPaymentPlans = (coupon?: ICoupon): IPlanMetadata[] => {
  if (!coupon) {
    return CURRENT_PLANS;
  }

  const couponPlanId = coupon.group.stripe_plan.external_id;
  const couponPlan = PREMIUM_PLANS.find(plan => plan.planID === couponPlanId);

  if (!couponPlan) {
    throw new Error(`Plan ${couponPlanId} for coupon not found`);
  }

  return [couponAdjustedPaymentPlan(couponPlan, coupon)];
};
